import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  subHeaderVariant: {
    description: 'productDetails.variantMessage',
    defaultMessage: 'This product is a variant for {name} (SKU: {sku}).',
    id: 'adP5vE',
  },
  subHeaderPreset: {
    description: 'productDetails.productProfileMessage',
    defaultMessage: 'Shipping defaults have been inherited from {name}.',
    id: 'U8hiZb',
  },
  productSku: {
    description: 'productDetails.skuLabel',
    defaultMessage: 'SKU',
    id: '2Kh1kn',
  },
  productType: {
    description: 'productDetails.productTypeLabel',
    defaultMessage: 'Product type',
    id: 'MY6M1l',
  },
  productName: {
    description: 'productDetails.nameLabel',
    defaultMessage: 'Name',
    id: 'LOnNVF',
  },
  activeLabel: {
    description: 'productDetails.isProductActive',
    defaultMessage: 'Active',
    id: 'fYPVq5',
  },
  overrideImportedNameLabel: {
    description: 'productDetails.useProductName',
    defaultMessage: 'Override the imported name',
    id: 'L6Kwr9',
  },
  productIsBundleLabel: {
    description: 'productDetails.IsBundle',
    defaultMessage: 'This is a bundled product',
    id: 'bKAI5h',
  },
  productIsBundleLabelV3: {
    description: 'productDetails.IsBundle.v3',
    defaultMessage: 'Product is a bundled product',
    id: 'wWXp1g',
  },
  close: {
    defaultMessage: 'Cancel',
    id: 'xNMR4H',
    description: 'productDetails.close',
  },
  save: {
    defaultMessage: 'Save',
    id: 'qeQm+f',
    description: 'productDetails.save',
  },
  shippingDefaults: {
    description: 'productDetails.shippingDefaults.title',
    defaultMessage: 'Shipping Defaults',
    id: 'wnyti0',
  },
  presetGroupLabel: {
    description: 'productDetails.presetGroupLabel',
    defaultMessage: 'Preset group',
    id: 'Y7MW24',
  },
  defaultPresetGroupText: {
    description: 'productDetails.defaultPresetGroupText',
    defaultMessage: 'None',
    id: 'UYfrP1',
  },
  shippingDefaultsSubHeader: {
    description: 'productDetails.aplliesOnlyToOne',
    defaultMessage: 'The following options will only apply to shipments containing quantity 1 of this product.',
    id: 'ghYUC4',
  },
  customsDefaultsSubHeader: {
    description: 'Product details customs tab sub-header',
    defaultMessage:
      'The following options will be used to create customs declarations for international shipments that contain this product.',
    id: 't2U/U7',
  },
  defaultServiceName: {
    description: 'productDetails.shippingDefaults.domesticService',
    defaultMessage: 'Domestic service',
    id: 'UgP2Gv',
  },
  defaultPackageName: {
    description: 'productDetails.shippingDefaults.domesticPackage',
    defaultMessage: 'Package',
    id: 'akMT9j',
  },
  defaultConfirmation: {
    description: 'productDetails.shippingDefaults.domesticConfirmation',
    defaultMessage: 'No Confirmation',
    id: 're0Ixf',
  },
  defaultInternationalServiceName: {
    description: 'productDetails.shippingDefaults.intlService',
    defaultMessage: 'International service',
    id: 'pYk8E1',
  },
  defaultInternationalPackageName: {
    description: 'productDetails.shippingDefaults.intlPackage',
    defaultMessage: 'Package',
    id: '4rgBFN',
  },
  defaultInternationalConfirmation: {
    description: 'productDetails.shippingDefaults.intlConfirmation',
    defaultMessage: 'No Confirmation',
    id: 'nuz/ae',
  },
  packageWeight: {
    description: 'productDetails.shippingDefaults.packageWeight',
    defaultMessage: 'Package weight',
    id: 'VYrMzs',
  },
  packageItemWeight: {
    description: 'productDetails.shippingDefaults.packageItemWeight',
    defaultMessage: 'Item weight',
    id: 'rNijYB',
  },
  warehouseLocation: {
    description: 'productDetails.shippingDefaults.warehouseLocation',
    defaultMessage: 'Warehouse location',
    id: '3DV1Yz',
  },
  packageDimensions: {
    description: 'productDetails.shippingDefaults.packageDimensions',
    defaultMessage: 'Package dimensions',
    id: 'XxGnKL',
  },
  packageItemDimensions: {
    description: 'productDetails.shippingDefaults.packageItemDimensions',
    defaultMessage: 'Item dimensions',
    id: 'HKInGJ',
  },
  dimsSourcePackageOption: {
    description: 'productDetails.shippingDefaults.dimsSourcePackageOption',
    defaultMessage: 'Package',
    id: 'Rrr/Hf',
  },
  dimsSourceItemOption: {
    description: 'productDetails.shippingDefaults.dimsSourceItemOption',
    defaultMessage: 'Item',
    id: 'PGF4e0',
  },
  fulfillmentSku: {
    description: 'productDetails.shippingDefaults.fulfillmentSku',
    defaultMessage: 'Fulfillment SKU',
    id: 'vNAt90',
  },
  presetGroupInfo: {
    description: 'productDetails.presetGroupInfo',
    defaultMessage: 'Preset -',
    id: 'UcA85s',
  },
  parentInfo: {
    description: 'productDetails.parentInfo',
    defaultMessage: 'Parent -',
    id: '7VHdG1',
  },
  applyToOpenOrders: {
    description: 'productDetails.applyToOpenOrders',
    defaultMessage: 'Apply changes to open orders',
    id: 'Uzdvly',
  },
  errorNotificationTitle: {
    description: 'productDetails.error',
    defaultMessage: 'Failed to save product details',
    id: 'sNuuRy',
  },
  errorNotificationMessageInventory: {
    description: 'productDetails.errorMessageInventory',
    defaultMessage: 'This product can not be deactivated, because it still has remaining inventory stock.',
    id: 'NKGvve',
  },
  errorNotificationMessageDuplicateSku: {
    description: 'productDetails.errorMessageDuplicateSku',
    defaultMessage: "Another product is already using one of the following SKU's. {duplicateSkuList}.",
    id: '+rLHwU',
  },
  errorNotificationProduSkuCannotMatchAlias: {
    description: 'productDetails.errorMessageProductSkuMatchesAliasSku',
    defaultMessage: 'The product can not have a store alias SKU matching its own current {skuList}.',
    id: 'iVjKSd',
  },
  errorNotificationProduDuplicateAliasWithStore: {
    description: 'productDetails.errorNotificationProduDuplicateAliasWithStore',
    defaultMessage: 'Another product is using SKU {skuList} with another store.',
    id: 'kWdTZa',
  },
  errorNotificationMessage: {
    description: 'productDetails.errorMessage',
    defaultMessage: 'An unexpected error occurred while trying to save updates to a product',
    id: 'Is3iT0',
  },
  generalTitle: {
    description: 'Sub-header of the product details general tab',
    defaultMessage: 'Attributes',
    id: 'Zhe7EF',
  },
  noAutoCustoms: {
    description: 'Product Details customs label do not include',
    defaultMessage: 'Do not create for products using this preset group',
    id: 'L03xtn',
  },
  customsTitle: {
    description: 'Product Details Customs Title',
    defaultMessage: 'Default Customs Declarations',
    id: 'r8el91',
  },
  declaredValue: {
    description: 'Product Details Declared Value',
    defaultMessage: 'Declared Value',
    id: 'nSM7Vy',
  },
  customsHarmonization: {
    description: 'Product Details Customs Harmonization',
    defaultMessage: 'Harmonization Code',
    id: 'p3g5Nj',
  },
  customsMIDCode: {
    description: 'Product Details Customs MID Code',
    defaultMessage: 'Manufacturer Identification (MID) Code',
    id: 'PSzyyK',
  },
  cpscCertificateVersionId: {
    description: 'Product Details CPSC Certificate Version ID',
    defaultMessage: 'Certificate Version ID',
    id: '+p55hW',
  },
  cpscCertifierId: {
    description: 'Product Details CPSC Certifier ID',
    defaultMessage: 'Certifier ID',
    id: 'iSWQon',
  },
  customsOriginCountry: {
    description: 'Product Details Customs Origin Country',
    defaultMessage: 'Origin Country',
    id: 'VCt8y7',
  },
  description: {
    description: 'Label for the description input in product details',
    defaultMessage: 'Description',
    id: 'xa7SFS',
  },
  imageUrl: {
    description: 'Label for the image url input in product details',
    defaultMessage: 'Image URL',
    id: 'PHjlES',
  },
  barcode: {
    description: 'Label for the barcode input in product details',
    defaultMessage: 'Barcode (UPC, ISBN, GTIN, etc.)',
    id: 'unDNPb',
  },
  upc: {
    description: 'Label for the upc input in product details',
    defaultMessage: 'UPC',
    id: 'mTKaZT',
  },
  price: {
    description: 'Label for the price input in product details',
    defaultMessage: 'Price',
    id: 'BEpnYx',
  },
  cost: {
    description: 'Label for the cost input in product details',
    defaultMessage: 'Cost',
    id: 'SBy5f6',
  },
  productCategories: {
    description: 'Label for the product categories input in product details',
    defaultMessage: 'Reporting Category',
    id: 'LG6au+',
  },
  orderTags: {
    description: 'Label for the order tags input in product details',
    defaultMessage: 'Order Tags',
    id: 'S8G5eg',
  },
  inheritedTags: {
    description: 'Label for the product inherited tags in product details',
    defaultMessage: 'Inherited Tags',
    id: '5TBmR7',
  },
  isReturnable: {
    description: 'Label for the returnable checkbox in product details',
    defaultMessage: 'Returnable',
    id: 'n5lX77',
  },
  isBundle: {
    description: 'Label for the Bundle checkbox in product details',
    defaultMessage: 'Bundle',
    id: 'IsreTR',
  },
  returnableMessage: {
    description: 'Message for the returnable checkbox in product details',
    defaultMessage: 'Product is returnable',
    id: 'W4VSQl',
  },
  imageUrlDescription: {
    description: 'Helper text for the image url in product details',
    defaultMessage: 'Supply an image url to override the image provided by the marketplace.',
    id: 'xKT0gF',
  },
  generalTab: {
    description: 'Tab title for the general tab in product details',
    defaultMessage: 'General',
    id: 'Psw8I/',
  },
  shippingTab: {
    description: 'Tab title for the Shipping tab in product details',
    defaultMessage: 'Shipping',
    id: '6rU5Xf',
  },
  productInventoryPreferences: {
    description: 'Title for the Inventory Preferences tab in product details',
    defaultMessage: 'Preferences',
    id: 'MlS6/3',
  },
  productInventoryTab: {
    description: 'Tab title for the Inventory tab in product details',
    defaultMessage: 'Inventory',
    id: 'jXz9+N',
  },
  adminHeader: {
    description: 'Admin tab header',
    defaultMessage: 'Admin',
    id: 'gMxEtI',
  },
  adminTab: {
    description: 'Tab title for the Admin tab in product details',
    defaultMessage: 'Admin',
    id: 's04B87',
  },
  productId: {
    description: 'Poduct Id label for the admin tab.',
    defaultMessage: 'Product Id',
    id: 'hyz6J/',
  },
  createDate: {
    description: 'Create Date label for the admin tab.',
    defaultMessage: 'Create Date',
    id: '2uQdlO',
  },
  modifiedDate: {
    description: 'modified date label for the admin tab.',
    defaultMessage: 'Modified Date',
    id: '/IgVsg',
  },
  hasHadInventory: {
    description: 'Has had Inventory label for the admin tab.',
    defaultMessage: 'Has Had Inventory',
    id: 'f1WhA3',
  },
  customsTab: {
    description: 'Tab title for the Customs tab in product details',
    defaultMessage: 'Customs',
    id: '4f25n5',
  },
  customsDeclarationsCheckbox: {
    description: 'Customs tab in product details checkbox',
    defaultMessage: 'Customs Declarations',
    id: 'XMUQs6',
  },
  productActivity: {
    description: 'Tab title for the product activity tab in product details',
    defaultMessage: 'Activity',
    id: 'vvgNxs',
  },
  unitsOfMeasureTab: {
    description: 'Tab title for the Units of Measure tab in product details',
    defaultMessage: 'Units of Measure',
    id: 'lvmW/r',
  },
  addWarehousesToProductErrorTitle: {
    description: 'title on notification window that displays when there is an error associating warehouses with a product',
    defaultMessage: 'Active Shipping Location Association Error',
    id: 'zlJM86',
  },
  addWarehousesToProductErrorMessage: {
    description:
      'description of the error displayed on the notification window that displays when there is an error associating warehouses with a product',
    defaultMessage: 'The selected Active Ship Froms could not be updated at this time. Please try again.',
    id: 'gvRlvS',
  },
  addTagsToProductErrorTitle: {
    description: 'products.addTagsToProductErrorTitle',
    defaultMessage: 'Tag Error',
    id: 'ibu97K',
  },
  addTagsToProductErrorMessage: {
    description: 'products.addTagsToProductErrorMessage',
    defaultMessage: 'Tags could not be changed at this time. Please try again.',
    id: 'YLGtb/',
  },
  errorNotificationMessageProductExport: {
    description: 'Error notification when a product export fails',
    defaultMessage: 'An error occurred while exporting products.',
    id: 'xkAyZa',
  },
  productExportCompleteTitle: {
    description: 'Title for product export complete notification',
    defaultMessage: 'Product Export Ready for Download',
    id: '4ju8oJ',
  },
  productExportCompleteBody: {
    description: 'Body for product export complete toast notification',
    defaultMessage: 'Your product export is ready. A download should have started automatically.',
    id: '/ivBZm',
  },
  productImportCompleteNotificationContent: {
    description: 'Product Import Notification Service Body',
    defaultMessage: 'Product Import Complete',
    id: 'NIQq6V',
  },
  productAliasImportCompleteNotificationContent: {
    description: 'Product Alias Import Notification Service Body',
    defaultMessage: 'Product Alias Import Complete',
    id: 'av/m5t',
  },
  productBundlesImportCompleteNotificationContent: {
    description: 'Product Bundles Import Notification Service Body',
    defaultMessage: 'Product Bundles Import Complete',
    id: 'aK36uY',
  },
  errorNotificationTitleProductImport: {
    description: 'Product Import Error Message Title',
    defaultMessage: 'An unexpected error occurred while trying to import products',
    id: '9fL/Z/',
  },
  errorNotificationMessageProductImport: {
    description: 'Product Import Error Message Body',
    defaultMessage: 'An unexpected error occurred while trying to save updates to a product. Please try again.',
    id: 'T15vbq',
  },
  errorNotificationTitleProductBundlesImport: {
    description: 'Product Bundles Import Error Message Title',
    defaultMessage: 'An unexpected error occurred while trying to import bundles',
    id: 'Pykjh6',
  },
  errorNotificationMessageProductBundlesImport: {
    description: 'Product Bundles Import Error Message Body',
    defaultMessage: 'An unexpected error occurred while trying to save updates to your bundles. Please try again.',
    id: 'MMS0uk',
  },
  autoSplitOption: {
    description: 'Product details Auto Split Option dropdown label',
    defaultMessage: 'Auto-split Option',
    id: 'StYzgJ',
  },
  autoSplitTooltip: {
    description: 'Product details Auto Split Option tooltip content',
    defaultMessage: 'Auto-split Option adjustments will not be applied to open orders. It will apply to any future imported orders.',
    id: 'ibDuZC',
  },
  none: {
    description: 'Product details no option groups',
    defaultMessage: 'None',
    id: 'AG4xMZ',
  },
  BYOLRestrictionsBannerText: {
    description: 'Information banner text related to BYOL order restrictions',
    defaultMessage: 'Shipping presets stored will not apply to selling channels that provide labels. <a>Learn More</a>',
    id: '0Mqytb',
  },
  productLocations: {
    description: 'Title for the Locations tab in product details',
    defaultMessage: 'Active Ship Froms for Routing',
    id: '9sm2mF',
  },
  productLocationsTab: {
    description: 'Tab title for the ACtive Ship Froms tab in product details',
    defaultMessage: 'Routing',
    id: 'eKWktu',
  },
  bundlesTab: {
    description: 'Tab title for the bundles tab in product details',
    defaultMessage: 'Bundle',
    id: 'y5vber',
  },
  productSelectionRequired: {
    description: 'Error message on a bundles component indicating a product must be selected from the auto fill dropdown.',
    defaultMessage: 'Please select a valid product',
    id: 'jCakTR',
  },
  bundleComponentWeight: {
    description: 'Information tooltip indicating the weight is calculated from the bundle components.',
    defaultMessage: 'The weight is the sum of all bundle component product weights',
    id: 'SlPl7n',
  },
  enableProductFee: {
    description: 'Information on how Product Fee will be implmented with fulfillment rates.',
    defaultMessage: 'Enable this product for Fulfillment Rates and specify the prices you charge for product and fulfillment costs.',
    id: 'Pv0C/X',
  },
  enableProductFeeHeader: {
    description: 'Header for product fee checkbox',
    defaultMessage: 'Enable for Fulfillment Rates',
    id: '8o8ai5',
  },
  enableProductFeeCheckbox: {
    description: 'Checkbox for enabling product fee checkbox',
    defaultMessage: 'Charge product and shipping fees when merchants delegate this product to you for fulfillment.',
    id: 'f9hxkK',
  },
  productFee: {
    description: 'Fee charged for product',
    defaultMessage: 'Product Fee',
    id: 'h3wzNr',
  },
  productFeeOverLimit: {
    description: 'Error label when user enters value over the limit allowed',
    defaultMessage: 'The maximum value for this field is $9,999,999.99',
    id: 'CQf9C9',
  },
  productWeight: {
    description: 'Weight of product',
    defaultMessage: 'Product Weight',
    id: '+O2nd1',
  },
  productDimensions: {
    description: 'Dimensions of product',
    defaultMessage: 'Product Dimensions',
    id: 'A8ZTRy',
  },
  shippingDefaultsTooltip: {
    description: 'Additional info as to what the shipping defaults are used for.',
    defaultMessage:
      'These package dimensions are also used by the Checkout Rates calculation method to determine the shipment’s dimensions. Dimensions often impact the shipment’s rate.',
    id: 'Of3Vot',
  },
  dangerousGoodsSectionTitle: {
    description: 'Header for the dangerous goods section',
    defaultMessage: 'Dangerous Goods',
    id: 'ZdTWA0',
  },
  dangerousGoodsSectionSubtitle: {
    description: 'Subtitle for the dangerous goods section',
    defaultMessage: 'This product is classified as dangerous goods.',
    id: 'ptX/ib',
  },
  storeAliasTab: {
    description: 'Tab title for SKU Alias tab in product details drawer v3',
    defaultMessage: 'SKU Alias',
    id: 'FONf6a',
  },
  drawerCloseAriaLabel: {
    description: 'Aria label for the close button on the product details drawer v3',
    defaultMessage: 'Close',
    id: 'txcgOv',
  },
  overviewSectionTitle: {
    description: 'Section title for Overview section in product details general tab v3',
    defaultMessage: 'Overview',
    id: 'SaJdxb',
  },
  imageSectionTitle: {
    description: 'Section title for Image section in product details general tab v3',
    defaultMessage: 'Image',
    id: 'FCS3C0',
  },
  productIsActiveLabel: {
    description: 'Toggle label for product is active in product details general tab v3',
    defaultMessage: 'Product is active',
    id: '3AEnRE',
  },
  productIsReturnableLabel: {
    description: 'Toggle label for product is returnable in product details general tab v3',
    defaultMessage: 'Product is returnable',
    id: '7wocGY',
  },
  shippingPreferencesTitle: {
    description: 'Section title for Shipping preferences in shipping tab v3',
    defaultMessage: 'Shipping preferences',
    id: 'pxf2FD',
  },
  locationDimensionsTitle: {
    description: 'Section title for Location & dimensions in shipping tab v3',
    defaultMessage: 'Location & dimensions',
    id: 'Jqd/E5',
  },
  dimensionsTitle: {
    description: 'Section title for Dimensions subsection in shipping tab v3',
    defaultMessage: 'Dimensions',
    id: 'aQpRu2',
  },
  locationTitle: {
    description: 'Section title for Location subsection in shipping tab v3',
    defaultMessage: 'Location',
    id: 'EETMHA',
  },
  requireSerialNumberLabel: {
    description: 'Toggle label for product requires serial number in general tab v3',
    defaultMessage: 'Product requires serial number',
    id: 'iTP+lu',
  },
  requireSerialNumberCaption: {
    description: 'Caption for product requires serial number toggle in general tab v3',
    defaultMessage: 'A serial number must be entered when packing orders that include this product',
    id: 'P2ihcX',
  },
  enableAutoSplitLabel: {
    description: 'Toggle label for enable auto-split in shipping tab v3',
    defaultMessage: 'Enable auto-split for this product',
    id: 'nSTIyq',
  },
  enableFulfillmentRatesLabel: {
    description: 'Toggle label for enable fulfillment rates in shipping tab v3',
    defaultMessage: 'Enable Fulfillment Rates',
    id: '074f6p',
  },
  enableFulfillmentRatesCaption: {
    description: 'Caption for enable fulfillment rates toggle in shipping tab v3',
    defaultMessage: 'Charge product and shipping fees when merchants delegate this product to you for fulfillment.',
    id: '4Lo9oG',
  },
  markDangerousGoodLabel: {
    description: 'Toggle label for marking product as dangerous good in shipping tab v3',
    defaultMessage: 'Mark this product as a dangerous good',
    id: 'lmalFJ',
  },
  hazmatSectionTitle: {
    description: 'Section title for the HAZMAT section in shipping tab v3',
    defaultMessage: 'Hazardous material',
    id: 'zCL7/T',
  },
  hazmatSectionInfoTooltip: {
    description: 'Tooltip for the info icon next to the HAZMAT section title',
    defaultMessage: 'Products marked as hazardous material will have the HAZMAT flag sent to LTL carriers on the eBOL.',
    id: '/ZfZw4',
  },
  markHazmatLabel: {
    description: 'Toggle label for marking product as hazardous material in shipping tab v3',
    defaultMessage: 'This product is a hazardous material (HAZMAT)',
    id: '8N9RN6',
  },
  hazmatToggleCaption: {
    description: 'Caption under the HAZMAT toggle in shipping tab v3',
    defaultMessage: 'When enabled, the hazmat flag is sent to LTL carriers on the eBOL.',
    id: 'xg7YVE',
  },
  customsDeclarationLabel: {
    description: 'Card header for customs declaration section in customs tab v3',
    defaultMessage: 'Customs Declaration',
    id: 'CM5sMb',
  },
  customsEnableDeclarationLabel: {
    description: 'Toggle label for enabling customs declaration for a product in customs tab v3',
    defaultMessage: 'Enable a customs declaration for this product',
    id: '/kyagC',
  },
  customsDeclarationSubtitle: {
    description: 'Subtitle text in customs declaration card in customs tab v3',
    defaultMessage:
      "Enter the product details required for customs declaration. We'll help you find the correct HS code based on your description.",
    id: 'qc/dK5',
  },
  customsDescriptionHelper: {
    description: 'Label for the description field in customs tab v3',
    defaultMessage: 'Enter a detailed description of the item',
    id: '61xbpX',
  },
  customsDescriptionExample: {
    description: 'Placeholder text for description textarea in customs tab v3',
    defaultMessage: "Ex: Men's nylon jacket, size L",
    id: 'stfDTx',
  },
  customsDescriptionFooter: {
    description: 'Helper text below description field in customs tab v3',
    defaultMessage: "Include what it is, what it's made of, and its use.",
    id: 'J5zmCx',
  },
  customsHarmonizationInfo: {
    description: 'Tooltip text for harmonization code info icon in customs tab v3',
    defaultMessage: 'The HS code classifies goods for international trade and is required for customs declarations.',
    id: 'wUnbnR',
  },
  customsMIDCodeInfo: {
    description: 'Tooltip text for MID code info icon in customs tab v3',
    defaultMessage: 'The Manufacturer Identification Code identifies the manufacturer or producer of the goods.',
    id: 'XsViNG',
  },
});
